import { DefaultTheme } from '../../../components/theme';

export const CSS = {
	container: 'c-FormEditField',
	isSelected: 'c-FormEditField--is-selected',
	title: 'c-FormEditField__title',
	isInvalid: 'c-FormEditField__title--invalid',
	label: {
		container: 'c-FormEditField__label',
		icon: 'c-FormEditField__labelIcon',
		text: 'c-FormEditField__labelText',
	},
	tag: {
		list: 'c-FormEditField__tags',
		tag: 'c-FormEditField__tag',
		cloneable: 'c-FormEditField__tag--cloneable',
		label: 'c-FormEditField__tag--label',
		status: 'c-FormEditField__tag--status',
	},
	form: {
		container: 'c-FormEditForm',
		children: 'c-FormEditForm__children',
	},
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		'align-items': 'center',
		['& button']: {
			'border-left': '2px solid transparent',
		},
	},
	[`${CSS.isSelected} .${CSS.title}`]: {
		'background-color': DefaultTheme.background.lightGrey,
		'border-left': `2px solid ${DefaultTheme.color.accent}`,
	},
	[CSS.tag.list]: {
		display: 'flex',
	},
	[CSS.tag.tag]: {
		'font-weight': 'bold',
		'font-size': '12px',
		'margin-left': '4px',
		'border-radius': '50%',
		'line-height': '16px',
		height: '16px',
		width: '16px',
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		border: '1px solid ' + DefaultTheme.background.grey,
		'background-color': DefaultTheme.background.lightGrey,
	},
	[CSS.tag.label]: {
		'border-radius': '50%',
		padding: 0,
	},
	[CSS.title]: {
		width: '100%',
		display: 'flex',
		'justify-content': 'space-between',
		'align-items': 'center',
		'padding-left': 0,
	},
	[CSS.isInvalid]: {
		[`& .${CSS.label.container}`]: {
			color: DefaultTheme.font.color.error,
		},
	},
	[CSS.label.container]: {
		color: DefaultTheme.font.color.primary,
		display: 'flex',
		'align-items': 'center',
		overflow: 'hidden',
	},
	[CSS.label.icon]: {
		padding: DefaultTheme.space(1),
		'text-align': 'center',
		'font-size': '18px',
		width: '18px',
		height: '18px',
	},
	[CSS.label.text]: {
		display: 'block',
		'text-align': 'left',
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
		'text-transform': 'none',
	},
	[CSS.form.children]: {
		'margin-left': DefaultTheme.space(5),
	},
};
